import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { registerSW } from 'virtual:pwa-register'
import './index.css'
import App from './Root.jsx'

Sentry.init({
  dsn: 'https://13943320b069a6607dbfed8d56d1f2ee@o4510472757575680.ingest.us.sentry.io/4510472761376768',
  sendDefaultPii: true,
  enabled: !window.location.hostname.includes('localhost'),
})

// Register service worker with auto-update
registerSW({
  immediate: true,
  onRegisteredSW(swUrl, r) {
    // Check for updates every hour
    r && setInterval(() => r.update(), 60 * 60 * 1000)
  }
})

// Preconnect to API based on environment
const apiBase = import.meta.env.VITE_API_BASE
if (apiBase) {
  const link = document.createElement('link')
  link.rel = 'dns-prefetch'
  link.href = apiBase
  document.head.appendChild(link)
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
